'use client'

// Tiny client component that hits DELETE /api/brand-unlock to clear
// the unlock cookie and reloads the page so the server-rendered gate
// kicks back in.

export function BrandLockButton() {
  return (
    <button
      type="button"
      onClick={async () => {
        await fetch('/api/brand-unlock', { method: 'DELETE' })
        window.location.reload()
      }}
      className="ml-auto text-xs text-muted-foreground hover:text-foreground"
    >
      Lock again
    </button>
  )
}
